import React from 'react'
import { Box, Container, Typography, Link, Stack, Divider } from '@mui/material'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import YouTubeIcon from '@mui/icons-material/YouTube'
import MusicNoteIcon from '@mui/icons-material/MusicNote'

const SOCIALS = [
  { href: 'https://facebook.com/EdProComUa', label: 'Facebook', Icon: FacebookIcon },
  { href: 'https://instagram.com/edpro.ua', label: 'Instagram', Icon: InstagramIcon },
  { href: 'https://youtube.com/@EdPro', label: 'YouTube', Icon: YouTubeIcon },
  { href: 'https://tiktok.com/@edproua', label: 'TikTok', Icon: MusicNoteIcon },
]

const LINKS = [
  { href: 'https://edpro.ua', label: 'Головна' },
  { href: 'https://edpro.ua/products', label: 'Продукти' },
  { href: 'https://edpro.ua/shop', label: 'Магазин' },
  { href: 'https://edpro.ua/about', label: 'Про нас' },
  { href: 'https://edpro.ua/blog', label: 'Блог' },
]

export default function AppFooter() {
  const year = new Date().getFullYear()
  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        py: 5,
        backgroundColor: '#1a1a1a',
        color: '#e6e6e6',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'grid',
            gap: 4,
            gridTemplateColumns: { xs: '1fr', md: '2fr 1fr 1fr' },
            alignItems: 'start',
          }}
        >
          <Box>
            <Link href="https://edpro.ua"  rel="noopener">
              <Box
                component="img"
                src="/edpro-logo.png"
                alt="EdPro"
                sx={{
                  height: 36, width: 'auto', display: 'block', mb: 2,
                  filter: 'brightness(0) invert(1)',
                }}
              />
            </Link>
            <Typography variant="body2" sx={{ color: '#bdbdbd', maxWidth: 420 }}>
              EdPro — український виробник інтерактивних панелей, лабораторного обладнання
              та програмного забезпечення для освіти.
            </Typography>
            <Typography
              variant="caption"
              sx={{ display: 'block', mt: 2, color: '#9a9a9a', fontStyle: 'italic' }}
            >
              Технології, які змінюють освіту
            </Typography>
          </Box>

          <Box>
            <Typography
              variant="overline"
              sx={{ color: '#f6b407', letterSpacing: 1.2, fontWeight: 700 }}
            >
              Навігація
            </Typography>
            <Stack spacing={0.75} sx={{ mt: 1 }}>
              {LINKS.map((link) => (
                <Link
                  key={link.href}
                  href={link.href}
                  rel="noopener"
                  underline="hover"
                  sx={{ color: '#e6e6e6', fontSize: 14 }}
                >
                  {link.label}
                </Link>
              ))}
            </Stack>
          </Box>

          <Box>
            <Typography
              variant="overline"
              sx={{ color: '#f6b407', letterSpacing: 1.2, fontWeight: 700 }}
            >
              Контакти
            </Typography>
            <Stack spacing={0.75} sx={{ mt: 1 }}>
              <Link
                href="tel:+380503172029"
                underline="hover"
                sx={{ color: '#e6e6e6', fontSize: 14 }}
              >
                (050) 317 20 29
              </Link>
              <Link
                href="mailto:support@edpro.ua"
                underline="hover"
                sx={{ color: '#e6e6e6', fontSize: 14 }}
              >
                support@edpro.ua
              </Link>
              <Typography variant="body2" sx={{ color: '#bdbdbd', fontSize: 14 }}>
                вул. Газова, 7<br />
                м. Львів, 79000
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
              {SOCIALS.map(({ href, label, Icon }) => (
                <Link
                  key={href}
                  href={href}
                  rel="noopener"
                  aria-label={label}
                  sx={{
                    color: '#e6e6e6',
                    display: 'inline-flex',
                    '&:hover': { color: '#f6b407' },
                  }}
                >
                  <Icon fontSize="small" />
                </Link>
              ))}
            </Stack>
          </Box>
        </Box>

        <Divider sx={{ my: 3, borderColor: '#2e2e2e' }} />

        <Typography variant="caption" sx={{ color: '#9a9a9a' }}>
          © 2017–{year} EdPro. Усі права захищені.
        </Typography>
      </Container>
    </Box>
  )
}
